import { FrequencyList } from "../components/student/frequency/FrequencyList"

export const Frequency = () => {
    return (
        <FrequencyList />
    )
}